<template>
  <PageWrapper
    :active-page="PAGE_PUBLICATION_OVERVIEW"
    :active-section="SECTION_PUBLICATIONS"
    title="My Publications"
    :breadcrumbs="publicationBreadCrumbs"
    page-name="Overview"
    align="left"
    width="full"
    action-button-text="Create New Publication"
    @click:action="navigateToCreatePublication"
  >
    <SmartFeedV2
      :source="useMyCollaboratorInviteFeedStore"
      default-feed-layout="carousel"
      default-entity-size="small"
    >
      <iSubHeading v-if="hasCollaboratorInvitations">
        Collaborator Invitations
      </iSubHeading>
    </SmartFeedV2>

    <iColumn v-if="myPublications?.length === 0">
      <iSpace :height="1" />
      <iText variant="subtle">
        No Publications Found. Create a new publication to get started.
      </iText>
    </iColumn>

    <SmartFeed
      :pinia-store="useActivePublicationFeedStore"
      default-smart-feed-layout="carousel"
      default-entity-layout="cardSmall"
      hide-content-if-empty
    >
      <iSubHeading>Active Publications</iSubHeading>
      <template #empty-state>
        <iText variant="subtle">
          You have no active publications
        </iText>
      </template>
    </SmartFeed>

    <SmartFeed
      :pinia-store="useDraftPublicationFeedStore"
      default-smart-feed-layout="carousel"
      default-entity-layout="cardSmall"
      hide-content-if-empty
    >
      <iSubHeading>Draft Publications</iSubHeading>
      <template #empty-state>
        <iText variant="subtle">
          You have no draft publications
        </iText>
      </template>
    </SmartFeed>

    <SmartFeed
      :pinia-store="useInactivePublicationFeedStore"
      default-smart-feed-layout="carousel"
      default-entity-layout="cardSmall"
      hide-content-if-empty
    >
      <iSubHeading>Inactive Publications</iSubHeading>
      <template #empty-state>
        <iText variant="subtle">
          You have no offline publications
        </iText>
      </template>
    </SmartFeed>
    <AddToNetworkModal />
    <ProposalReviewModal
      v-if="isProposalReviewModalVisible"
      :proposal="selectedProposalReview"
      @close="closeProposalReviewModal"
      @accept="onAcceptInvitation"
      @decline="onDeclineInvitation"
      @counter="onCounterInvitation"
    />

    <CounterOfferModal
      v-if="isCounterOfferModalVisible"
      :proposal="selectedProposalForCounter"
      @close="closeCounterOfferModal"
      @cancel="onCancelCounterOffer"
      @submit="onSubmitCounterOffer"
    />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  PAGE_PUBLICATION_OVERVIEW,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import { mapState } from "pinia";

import SmartFeed from "SmartFeed/components/SmartFeed";
import SmartFeedV2 from "SmartFeed/components/SmartFeedV2.vue";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { useActivePublicationFeedStore } from "SmartFeed/stores/feed/active-publication-feed-store";
import { useDraftPublicationFeedStore } from "SmartFeed/stores/feed/draft-publication-feed-store";
import { useInactivePublicationFeedStore } from "SmartFeed/stores/feed/inactive-publication-feed-store";
import AddToNetworkModal from "@/components/networks/AddToNetworkModal.vue";
import { useMyCollaboratorInviteFeedStore } from "@/smart-feed/stores/feed/my-collaborator-invite-feed-store";
import ProposalReviewModal from "@/components/publication/ProposalReviewModal.vue";
import CounterOfferModal from "@/components/publication/CounterOfferModal.vue";
import collaboratorInviteMixin from "@/mixins/collaborator-invite-mixin";

export default {
  name: "PublicationOverview",
  components: {
    CounterOfferModal,
    ProposalReviewModal,
    SmartFeed,
    PageWrapper,
    AddToNetworkModal,
    SmartFeedV2,
  },
  mixins: [collaboratorInviteMixin],
  data() {
    return {
      PAGE_PUBLICATION_OVERVIEW,
      SECTION_PUBLICATIONS,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, ["orgId", "myPublications"]),
    hasCollaboratorInvitations() {
      const collaboratorInviteStoreInstance = this.useMyCollaboratorInviteFeedStore();
      return (collaboratorInviteStoreInstance.feed || []).length > 0;
    },
    publicationBreadCrumbs() {
      return [{ url: "/", label: "Home" }, { url: `/publication/org/${this.orgId}/overview`, label: "My Publications" }];
    },
  },
  methods: {
    useMyCollaboratorInviteFeedStore,
    useActivePublicationFeedStore,
    useDraftPublicationFeedStore,
    useInactivePublicationFeedStore,
    navigateToCreatePublication() {
      window.location = `/publication/org/${this.orgId}/create`;
    },
  },
};
</script>
